import React from 'react';
import PropTypes from 'prop-types';

export default function AddressPredictions({ predictions, onSelect }) {
  if (!predictions.length) {
    return null;
  }

  return (
    <div aria-label="predictions" className="dropdown">
      <div className="dropdown-menu show w-100">
        {predictions.map((prediction, i) => (
          <button
            aria-label="prediction"
            className="dropdown-item text-wrap"
            key={i}
            type="button"
            onClick={() => onSelect(prediction)}
          >
            {prediction.description}
          </button>
        ))}
      </div>
    </div>
  );
}

AddressPredictions.propTypes = {
  predictions: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
};
